import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import axiosInstance from './helpers/httpInterceptor';

import "../src/design/app.scss";

import store from '@/state/store'

import App from './App.vue'

/* import { initFirebaseBackend } from './authUtils' */
import i18n from './i18n'

/* import { configureWellyBackend } from './helpers/welly-backend'; */

import tinymce from 'vue-tinymce-editor'

import refreshTokenPlugin from './state/refreshTokenPlugin'
import VueNativeNotification from 'vue-native-notification'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

Vue.component('tinymce', tinymce)
Vue.use(VueRouter)

Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
        libraries: 'places',
    },
    installComponents: true
})
Vue.component('apexchart', VueApexCharts)

Vue.use(refreshTokenPlugin);

Vue.use(VueNativeNotification, {
    requestOnNotify: true
})

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.prototype.$http = axiosInstance;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
